import { getHistoricMovementsByDateUseCase, getHistoricOpsByDateUseCase, getHistoricMovementsFilteredUseCase, getHistoricOpsFilteredUseCase } from '../../../di/usecase_module';
import { Sell } from '../../../domain/models/Sell';
import { GetHistoricMovementsByDateRequestDto } from '../../../domain/usecases/historic/GetHistoricMovementsByDateUseCase';
import { GetHistoricOpsByDateRequestDto } from '../../../domain/usecases/historic/GetHistoricOpsByDateUseCase';
import { handleError } from '../../utils/handleError';
import { ActionType } from '../ActionsTypes';
import { ReducerAction } from '../ReducerAction';
import { ModalMovState } from '../states/ModalMovState';
import { QueryByType } from '../../../domain/constants/QueryByType';
import { UIActions } from './UIActions';
import { GetHistoricMovementsFilteredDto } from '../../../domain/usecases/historic/GetHistoricMovementsFiltered';
import { GetHistoricOpsFilteredDto } from '../../../domain/usecases/historic/GetHistoricOpsFiltered';
import { dateTimeZone } from '../../utils/dateTimeZone';

export class ModalMovActions {

    static open(setup: ModalMovState) {
        return (dispatch: any) => {
            dispatch(UIActions.openModalMov());
            dispatch(ModalMovActions.setup(setup));
            if (!setup.isCustom) {
                dispatch(ModalMovActions.getData(setup));
            }
        }
    }

    static close() {
        return (dispatch: any) => {
            dispatch(UIActions.closeModalMov());
        }
    }

    static setup(setup: ModalMovState): ReducerAction {
        return {
            type: ActionType.MODALMOV_SETUP,
            payload: setup
        }
    }

    static setData(data: Sell[]): ReducerAction {
        return {
            type: ActionType.MODALMOV_SET_DATA,
            payload: data
        }
    }

    static setDataAll(data: Sell[]): ReducerAction {
        return {
            type: ActionType.MODALMOV_SET_DATA_ALL,
            payload: data
        }
    }

    static setDate(date: Date): ReducerAction {
        return {
            type: ActionType.MODALMOV_SET_DATE,
            payload: date
        }
    }

    static setDateEnd(date: Date | undefined = undefined): ReducerAction {
        return {
            type: ActionType.MODALMOV_SET_DATE_END,
            payload: date
        }
    }

    static setPage(page: number): ReducerAction {
        return {
            type: ActionType.MODALMOV_SET_PAGE,
            payload: page
        }
    }
    static setQueryType(queryType: QueryByType): ReducerAction {
        return {
            type: ActionType.MODALMOV_SET_QUERYTYPE,
            payload: queryType
        }
    }

    static setCustom(isCustom: boolean): ReducerAction {
        return {
            type: ActionType.MODALMOV_SET_CUSTOM,
            payload: isCustom
        }
    }

    static getMovements(modalState: ModalMovState, all: boolean = false) {
        return (dispatch: any) => {
            const date = dateTimeZone(modalState.date);
            let promise: Promise<Sell[]>;
            if (modalState.queryType === QueryByType.FILTER) {
                const dateEnd = dateTimeZone(modalState.dateEnd);
                //TODO Mostrar error si dateEnd no existe;
                promise = getHistoricMovementsFilteredUseCase().execute(
                    new GetHistoricMovementsFilteredDto(
                        date,
                        dateEnd,
                        modalState.page,
                        all
                    )
                );
            } else {
                promise = getHistoricMovementsByDateUseCase().execute(
                    new GetHistoricMovementsByDateRequestDto(
                        modalState.queryType,
                        date, modalState.page, all)
                )
            }

            promise.then((result: any) => {
                if (all) {
                    dispatch(ModalMovActions.setDataAll(result));
                } else {
                    dispatch(ModalMovActions.setData(result));
                }
            }).catch((e) => {
                handleError(e);
            })

        }
    }

    static getOps(modalState: ModalMovState, all: boolean = false) {
        return (dispatch: any) => {
            const date = dateTimeZone(modalState.date);
            let promise: Promise<Sell[]>;

            if (modalState.queryType === QueryByType.FILTER) {
                const dateEnd = dateTimeZone(modalState.dateEnd);
                promise = getHistoricOpsFilteredUseCase().execute(
                    new GetHistoricOpsFilteredDto(
                        date,
                        dateEnd,
                        modalState.page,
                        all
                    )
                );
            } else {
                promise = getHistoricOpsByDateUseCase().execute(
                    new GetHistoricOpsByDateRequestDto(
                        modalState.queryType,
                        date, modalState.page, all)
                );
            }
            promise.then((result: any) => {
                if (all) {
                    dispatch(ModalMovActions.setDataAll(result));
                } else {
                    dispatch(ModalMovActions.setData(result));
                }
            }).catch((e) => {
                handleError(e);
            })
        }
    }

    static getData(modalState: ModalMovState) {
        return (dispatch: any) => {

            if (modalState.isResume) {
                dispatch(ModalMovActions.getMovements(modalState))
                dispatch(ModalMovActions.getMovements(modalState, true))
            } else {
                dispatch(ModalMovActions.getOps(modalState));
                dispatch(ModalMovActions.getOps(modalState, true));
            }

        }
    }

    static reset(): ReducerAction {
        return {
            type: ActionType.MODALMOV_RESET
        };
    }

}

